export const RESTRICTED_EMAIL_DOMAINS = ['ru', 'by', 'рф', 'рус', 'бел'];
export const RESTRICTED_COUNTRIES_ISO_CODES = ['RU', 'BY'];
